var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 447,
    height: 650,
    viewBox: "0 0 447 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_855)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.6161,
    cy: 315.616,
    r: 140.616,
    fill: "#DD00AC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1_855)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 143.308,
    cy: 344.54,
    r: 111.692,
    fill: "#7064E9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_855",
    x: -368,
    y: -84,
    width: 799.232,
    height: 799.232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 129.5,
    result: "effect1_foregroundBlur_1_855"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_855",
    x: -160.384,
    y: 40.8484,
    width: 607.384,
    height: 607.384,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 96,
    result: "effect1_foregroundBlur_1_855"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftback);
export default __webpack_public_path__ + "static/media/leftback.f7471946e32af408d36fa952a4208711.svg";
export { ForwardRef as ReactComponent };